import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    close: 'Exit',
    description:
      'These documents will be refused and will slow down the opening of your account.',
    incomeTaxNotice: '{lastYear} tax assessment',
    nonAcceptedDocsLabel: 'List of unsupported documents',
    nonAcceptedDocsList: [
      'Mobile phone bill',
      'Cancellation invoices',
      'Certificate of home insurance',
      'Annual gas, water or electricity bill',
    ],
  },
  fr: {
    close: 'Fermer',
    description:
      'Ces documents seront refusés et ralentiront l’ouverture de votre compte.',
    incomeTaxNotice: 'Avis d’imposition {lastYear}',
    nonAcceptedDocsLabel: 'Liste des documents non pris en charge',
    nonAcceptedDocsList: [
      'Facture de téléphone mobile',
      'Facture de résiliation ou de clôture',
      'Attestation d’assurance habitation',
      'Facture annuelle de gaz, d’eau ou d’électricité',
    ],
  },
} as const);
